import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import promMaterialsListSaga from './sagas/promMaterialsListSaga';

export default [
  // Lists
  ...createCombineMapItem('promMaterialsList', createListReduceObject, [
    promMaterialsListSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/promotionalMaterials/reducers/static/lists/reducersMap.js